import { fromJS } from 'immutable';
import pixelWidth from 'string-pixel-width';
import MathHelper from './MathHelper';


export default class TextBoxHelper {
  static create(pieceId, { id, x, y, title = 'New Text', rotation = 0, points = 60 }) {
    return fromJS({ id, pieceId, title, x, y, points, rotation });
  }

  static delta(textBox, delta) {
    return {
      ...textBox,
      x: textBox.x + delta.x,
      y: textBox.y + delta.y,
    };
  }

  static getBounds(textBox) {
    const { x, y, rotation, points } = textBox;

    let xMin = Number.MAX_VALUE;
    let yMin = Number.MAX_VALUE;
    let xMax = Number.MIN_VALUE;
    let yMax = Number.MIN_VALUE;

    let textLength = pixelWidth(textBox.title, { size: textBox.points });
    if (Number.isNaN(textLength)) { // this occurring when the user introduce unicode characters
      textLength = pixelWidth(textBox.title.charCodeAt(0), { size: textBox.points });
    }
    const textHeight = points * 0.72;

    const angle = MathHelper.convertDegreesToRadians(rotation);
    const complementaryAngle = MathHelper.convertDegreesToRadians((rotation - 90));

    const bottomRight = {
      x: x + MathHelper.getAdjacentLength(textLength, angle),
      y: y + MathHelper.getOppositeLength(textLength, angle),
    };

    const relativeTopLeft = {
      x: MathHelper.getAdjacentLength(textHeight, complementaryAngle),
      y: MathHelper.getOppositeLength(textHeight, complementaryAngle),
    };

    const topLeft = {
      x: x + relativeTopLeft.x,
      y: y + relativeTopLeft.y,
    };

    const topRight = MathHelper.addPoints(bottomRight, relativeTopLeft);

    const textCorners = [{ x, y }, bottomRight, topLeft, topRight];

    textCorners.forEach((point) => {
      xMin = xMin < point.x ? xMin : point.x;
      xMax = xMax > point.x ? xMax : point.x;
      yMin = yMin < point.y ? yMin : point.y;
      yMax = yMax > point.y ? yMax : point.y;
    });

    if (xMin === Number.MAX_VALUE || yMin === Number.MAX_VALUE
      || xMax === Number.MIN_VALUE || yMax === Number.MIN_VALUE) {
      return { x: 0, y: 0, w: 0, h: 0 };
    }
    const bounds = { x: xMin, y: yMin, w: xMax - xMin, h: yMax - yMin };

    return bounds;
  }
}
